import { reveal } from "@components/animations";
import emailjs from "@emailjs/browser";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import { hexToRGBA } from "@utils/hex-to-rgba";
import { addScriptDefault } from "meta-pixel";
import React, { CSSProperties, useRef } from "react";
import toast from "react-hot-toast";
export default function ContactFrom() {
  const theme = useTheme();
  const fillStyle = {
    "--anim-fill-color": hexToRGBA(theme.palette.primary.main, 0.2),
  } as CSSProperties;
  const formRef = useRef<HTMLFormElement>(null);
  const [error, setError] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<{
    name: string;
    email: string;
    subject: string;
    message: string;
  }>({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);
    e.preventDefault();
    try {
      const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID as string;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID as string;
      const publicId = process.env.REACT_APP_EMAILJS_PUBLIC_KEY as string;
      const sendMail = await emailjs.sendForm(
        serviceId,
        templateId,
        formRef.current!,
        {
          publicKey: publicId,
        }
      );

      if (sendMail.status === 200) {
        const fbq = addScriptDefault();
        fbq("trackCustom", "Subscribe", {
          data: data,
        });

        setData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setError("");
        toast.success("Message sent successfully", { position: "top-right" });
      }
    } catch (error) {
      setError("Something went wrong, Please try again later");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Stack spacing={2} py={8} {...reveal("up", 120)}>
      <form onSubmit={handleSubmit} ref={formRef}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Name"
              name="name"
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Email"
              name="email"
              value={data.email}
              type="email"
              onChange={(e) => setData({ ...data, email: e.target.value })}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Subject"
              name="subject"
              value={data.subject}
              onChange={(e) => setData({ ...data, subject: e.target.value })}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Message"
              name="message"
              value={data.message}
              onChange={(e) => setData({ ...data, message: e.target.value })}
              fullWidth
              required
              multiline
              minRows={4}
              maxRows={8}
            />
          </Grid>
          {error && (
            <Grid item xs={12}>
              <Typography color="error">{error}</Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Button
              variant="outlined"
              color="primary"
              type="submit"
              className="anim-fill"
              style={fillStyle}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <CircularProgress color="inherit" size={20} sx={{ mr: 1 }} />{" "}
                  Loading...
                </>
              ) : (
                "Send Message"
              )}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Stack>
  );
}
